import { useNavigate } from 'react-router';
import {
  PageHeader,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Badge,
  Button,
} from '@redbax/ui-kit';
import { usePackagePolicies } from '../api/package-policy-hooks';

export function PackageAllowlistPage() {
  const navigate = useNavigate();
  const { data: policies } = usePackagePolicies();

  return (
    <div>
      <PageHeader
        title="Package Allowlist"
        description="Allowlists are now managed per ecosystem policy. Select an ecosystem to manage its allowlist."
      />

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Ecosystem Policies</CardTitle>
        </CardHeader>
        <CardContent>
          {(!policies || policies.length === 0) ? (
            <p className="text-sm text-text-secondary">
              No package policies configured. Create one from the Package Security page.
            </p>
          ) : (
            <div className="flex flex-wrap gap-2">
              {policies.map((p) => (
                <Button
                  key={p.id}
                  variant="outline"
                  onClick={() =>
                    navigate(
                      `/package-security/policies/${encodeURIComponent(p.ecosystem)}`,
                    )
                  }
                >
                  <Badge variant="outline" className="mr-2">
                    {p.ecosystem}
                  </Badge>
                  Manage Allowlist
                </Button>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
